/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_GuideInputs */

const en_user_guide = /** @type {(inputs: User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Guide`)
};

const fr_user_guide = /** @type {(inputs: User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide de l’utilisateur`)
};

const de_user_guide = /** @type {(inputs: User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerhandbuch`)
};

const it_user_guide = /** @type {(inputs: User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guida per l'utente`)
};

const ru_user_guide = /** @type {(inputs: User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Руководство пользователя`)
};

const es_user_guide = /** @type {(inputs: User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guía del usuario`)
};

const zh_cn2_user_guide = /** @type {(inputs: User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户指南`)
};

const ja_user_guide = /** @type {(inputs: User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーガイド`)
};

const hi_user_guide = /** @type {(inputs: User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता गाइड`)
};

const pt_pt2_user_guide = /** @type {(inputs: User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guia do Usuário`)
};

/**
* | output |
* | --- |
* | "User Guide" |
*
* @param {User_GuideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const user_guide = /** @type {((inputs?: User_GuideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_GuideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_user_guide(inputs)
	if (locale === "de") return de_user_guide(inputs)
	if (locale === "it") return it_user_guide(inputs)
	if (locale === "ru") return ru_user_guide(inputs)
	if (locale === "es") return es_user_guide(inputs)
	if (locale === "zh-CN") return zh_cn2_user_guide(inputs)
	if (locale === "ja") return ja_user_guide(inputs)
	if (locale === "hi") return hi_user_guide(inputs)
	if (locale === "pt-PT") return pt_pt2_user_guide(inputs)
	return en_user_guide(inputs)
});